// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"69383122","455":"50ecbe1a","977":"81a2e945"}[chunkId] + ".chunk.js";
};